import { useState, useCallback } from "react";
import { customFetch, getFormApi } from "../Utils/customFetch";
import { useAppContext } from "../AppProvider/AppProvider";


export function UseApi() {
  const [error, setError] = useState(null);
  const { loading, setLoading, loggedIn, setLoggedIn, user, setUser } = useAppContext();

  /** proxy para customFetch */
  const fetchApi = useCallback(
    async (path, options = {}) => {
      setLoading(true);
      setError(null);
      try {
        return await customFetch(path, options);
      } catch (err) {
        setError(err);
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  /** proxy para getFormApi */
  const fetchSchema = useCallback(
    async (url) => {
      setLoading(true);
      setError(null);
      try {
        return await getFormApi(url);
      } catch (err) {
        setError(err);
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return { loading, error, fetchApi, fetchSchema };
}
